import { captureException } from "@sentry/sveltekit"
import { toastAlert } from "$lib/commons-web2/toast-alert"
import {
  setReporter,
  isHandledError,
  getGenericAlert,
  type ReportOptions,
} from "@tastyworks/error-handling"

export function reportError(
  e: unknown,
  { alertUser = true }: ReportOptions = {}
) {
  let alertTitle: string
  let alertMsg: string
  let isSentryIgnored = false
  let fingerprint = ["{{ default }}"] // Default fingerprint defined by Sentry docs

  if (isHandledError(e)) {
    const { title, message } = e.userFriendlyDisplay
    alertTitle = title
    alertMsg = message
    isSentryIgnored = e.isSentryIgnored()
    fingerprint = e.fingerprint ?? fingerprint
  } else {
    // Should not hit this block; needed until we have full type safety
    const { title, message } = getGenericAlert()
    alertTitle = title
    alertMsg = message
  }

  console.error(e)

  if (!isSentryIgnored) {
    captureException(e, { fingerprint })
  }

  if (alertUser) {
    toastAlert("error", alertTitle, alertMsg)
  }
}

setReporter({ reportError })
